import {
    validateEmail,
    validatePostalCode,
    validateFirstName,
    validateLastName,
    validateAddress,
    validateCity,
    validateStateId,
    validateDay,
    validateMonth,
    validateYear
} from '../Shared/validations.js';

const validate = values => {
    const errors = {
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validatePostalCode(values),
        ...validateAddress(values),
        ...validateCity(values),
        ...validateStateId(values),
        ...validateEmail(values),
        ...validateDay(values),
        ...validateMonth(values),
        ...validateYear(values)
    };
    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/CheckRegistration/validations.js